import React from 'react'
import { PublicAdministrationRegisterForm } from '../../../../../domain/feature/hotsite/Forms/NewPublicOrganRegister/v1'

export const HotsitePublicAdministrationRegisterPage = (): JSX.Element => {
  return (
    <>
      <PublicAdministrationRegisterForm />
    </>
  )
}
